import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import Topbar from "./topbar";
import HeaderBody from "./header-body";
import { postUserLog, fetchWishlist, fetchWishlistCount, fetchCompare, fetchCompareCount } from "../../actions";

import "./css/sunny-diamond.css";
import classes from "./css/header.module.scss";
import { Helmet } from "react-helmet";

const Header = (props) => {
  const [navigationData, setNavigationData] = useState({});
  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const threshold = window.innerWidth < 768 ? 0 : 300;
      setIsFixed(window.scrollY > threshold);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("user_type") === "CUSTOMER" && localStorage.getItem("token");
    if (isLoggedIn) {
      props.fetchWishlist();
      props.fetchWishlistCount();
      props.fetchCompare();
      props.fetchCompareCount();
    }
  }, [props.user_type]);

  useEffect(() => {
    const observer = new PerformanceObserver((list) => {
      const entries = list.getEntries();

      const entryActions = {
        navigation: (entry) =>
          setNavigationData(JSON.stringify(entry.toJSON())),
      };

      entries.forEach((entry) => {
        const entryType = entry.entryType;
        const action = entryActions[entryType];
        if (action) {
          action(entry);
        }
      });
    });

    observer.observe({
      entryTypes: ["navigation"],
    });

    return () => {
      observer.disconnect();
    };
  }, [props.location]);

  useEffect(() => {
    getLocationData();
  }, [navigationData, props.location]);

  const getLocationData = () => {
    fetch("https://geolocation-db.com/json/")
      .then((response) => {
        response
          .json()
          .then((data) => {
            var userLog = {
              visited_page: window.location.href,
              ip_address: data.IPv4,
              address:
                Object.keys(navigationData).length != 0
                  ? navigationData
                  : "Not found",
              latitude: data.latitude == "Not found" ? 0 : data.latitude,
              longitude: data.longitude == "Not found" ? 0 : data.longitude,
              user_id:
                navigator.cookieEnabled && localStorage.getItem("user_id"),
            };
            props.postUserLog(userLog);
          })
          .catch(() => {
            var userLog = {
              visited_page: window.location.href,
              address:
                Object.keys(navigationData).length != 0
                  ? navigationData
                  : "Not found",
              user_id:
                navigator.cookieEnabled && localStorage.getItem("user_id"),
            };
            props.postUserLog(userLog);
          });
      })
      .catch(() => {
        var userLog = {
          visited_page: window.location.href,
          address:
            Object.keys(navigationData).length != 0
              ? navigationData
              : "Not found",
          user_id: navigator.cookieEnabled && localStorage.getItem("user_id"),
        };
        props.postUserLog(userLog);
      });
  };

  return (
    <div
      className={`${classes.sunny_header} ${
        isFixed ? classes.headerFixed : ""
      }`}
    >
      <Helmet>
        <meta property="og:url" content={window.location.href} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <Topbar topbarText={window.navLinksTop.topBarText} />
      <HeaderBody
        isFixed={isFixed}
        navBar={window.navLinksTop.navBar}
        wishListItems={props.wishListItems}
        wishlistCount={props.wishlistCount}
        compareItems={props.compareItems}
        compareCount={props.compareCount}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  wishListItems: state.wishlist.list,
  wishlistCount: state.wishlist.count,
  compareItems: state.compare.items,
  compareCount: state.compare.count,
  user_type: state.data.user_type,
});

export default connect(mapStateToProps, { postUserLog, fetchWishlist, fetchWishlistCount, fetchCompare, fetchCompareCount })(Header);
